module.exports = __webpack_public_path__ + "static/img/275_TO8_2402_og.d244555.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/275_TO8_2402_og.jpg
// module id = IdHk
// module chunks = 0